"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _colors = _interopRequireDefault(require("../../styles/colors"));
var PaginationDots = function PaginationDots(_ref) {
  var count = _ref.count,
    activeIndex = _ref.activeIndex;
  return /*#__PURE__*/_react["default"].createElement(Container, null, Array.from({
    length: count
  }).map(function (_, index) {
    return /*#__PURE__*/_react["default"].createElement(Dot, {
      key: index,
      $isActive: index === activeIndex
    });
  }));
};
var _default = exports["default"] = PaginationDots; // -------------------------- Styles -------------------------- //
var Container = _styledComponents["default"].div.withConfig({
  displayName: "PaginationDots__Container",
  componentId: "sc-1f4jqog-0"
})(["display:flex;align-items:center;gap:8px;"]);
var Dot = _styledComponents["default"].div.withConfig({
  displayName: "PaginationDots__Dot",
  componentId: "sc-1f4jqog-1"
})(["width:8px;height:8px;border-radius:50%;transition:background-color 200ms;background-color:", ";"], function (_ref2) {
  var $isActive = _ref2.$isActive;
  return $isActive ? _colors["default"].neutral900 : _colors["default"].neutral500;
});
//# sourceMappingURL=PaginationDots.js.map